<template>
  <div class="form-registro1">
    <main class="container registro p-5 d-flex justify-content-center">
        
            <div v-if="formulario == 1">
              <form @submit.prevent="submit1" id="form1" class="p-5 registro-2 ">
                <router-link to="/inicio">
                <img class="mb-4 mx-auto d-block logo-kallpa" src="@/assets/img/logo.png" alt="" width="" >
                </router-link>
             <h1 class="titulo-registro text-center m-t-1">Registrarme</h1>
                    <ul class="step d-flex flex-nowrap">
                        <li class="step-item ">
                            <a  @click="formulario=1" id="step1"></a>
                        </li>
                        <li class="step-item active">
                           <a v-if="button2==1" @click="formulario=2"  id="step2"></a>
                           <a v-else  id="step2"></a>
                        </li>
                        <li class="step-item">
                            <a v-if="button3==1" @click="formulario=3" id="step3"></a>
                            <a v-else  id="step3"></a>
                        </li>
                         <li class="step-item" id="step4">
                            <a v-if="button4==1" @click="formulario=4" id="step4"></a>
                            <a v-else  id="step4"></a>
                        </li>
                    </ul> <br>
                    <p class="text-left" style="color: #1BCA59;">Todos los campos marcados (*) son obligatorios</p>
              <h5 class="sub-titulo text-center">Datos personales</h5>
              <div class="row g-3">
              <div class="col-md-12">
                  <label for="firstName" class="form-label">Nombres *</label>
                  <input type="text" class="form-control" id="firstName" name="firstName"  v-model="registerForm.DatosPersonales.Nombres" @keypress="soloLetrasSimples" required>
                </div>

                <div class="col-md-12">
                  <label for="lastName" class="form-label">Apellidos *</label>
                  <input type="text" class="form-control" id="lastName" name="lastName"   v-model="registerForm.DatosPersonales.Apellidos" @keypress="soloLetrasSimples" required>
                </div>

                <div class="col-md-12">
                  <label for="Celular" class="form-label">Número de teléfono celular *</label>
                  <input type="text" class="form-control" id="Celular" name="Celular"  v-model="registerForm.DatosPersonales.Celular" @keypress="soloNumeros" maxlength="9"  required>
                </div>

                <div class="col-md-12">
                  <label for="FechaNacimiento" class="form-label">Fecha de nacimiento *</label>
                  <input type="date" class="form-control" id="FechaNacimiento" name="FechaNacimiento" placeholder="dd/mm/yyyy"  v-model="registerForm.DatosPersonales.FechaNacimiento"  required>  
                </div>

              <div class="col-md-12">
                  <label for="Nacionalidad1" class="form-label">Nacionalidad *</label>
                  <select class="form-select" aria-label="Default select example" id="Nacionalidad1" name="Nacionalidad1" v-model="registerForm.DatosPersonales.Nacionalidad"  required>
                    <option v-for="(linea,index) in selectPais" :key="index" :value="linea.IdPais" v-text="linea.NombrePais" ></option></select>
                </div>
    
                <div class="col-md-12">
                  <label for="Email" class="form-label">Correo electrónico *</label>
                  <input type="email" class="form-control" id="Email" name="Email" placeholder="name@example.com" v-model="registerForm.DatosPersonales.Email"  required>
                </div> 

                <div class="col-md-12">
                    <label for="Clave" class="form-label">Crea tu clave *</label>
                    <div class="input-group">
                      <input type="password" class="form-control" id="Clave" name="Clave" placeholder="*********" v-model="registerForm.DatosPersonales.Clave" v-validate="'required|min:5|verify_password'" ref="password" required>
                      <div class="input-group-append">
                            <button id="show_password" class="btn btn-outline-secondary" type="button" @click="mostrarClave"> <span class="fa fa-eye-slash icon1"></span> </button>
                          </div>
                     </div>
                </div>
                <div class="col-md-12">
                    <label for="ClaveRepetida" class="form-label">Repite tu clave *</label>
                    <div class="input-group">
                      <input type="password" class="form-control" id="ClaveRepetida" name="ClaveRepetida" placeholder="*********" v-model="registerForm.DatosPersonales.Clave2" v-validate="'required|confirmed:password'" required>
                      <div class="input-group-append">
                            <button id="show_passwordRepetida" class="btn btn-outline-secondary" type="button" @click="mostrarClaveRepetida"> <span class="fa fa-eye-slash icon2"></span> </button>
                          </div>
                    </div>
                </div>
                <div class="alert alert-danger" v-show="errors.any()">
                  <div v-if="errors.has('Clave')">
                    {{ errors.first('Clave')}}
                  </div>
                  <div v-if="errors.has('ClaveRepetida')">
                    {{ errors.first('ClaveRepetida')}}
                  </div>
                </div>
                <div class="col-md-12 d-flex justify-content-end">
                    <button type="submit"  class="btn btn-light">Siguiente <i class="fas fa-arrow-right"></i></button></div>
              </div>
              </form>
          </div>
          <div v-if="formulario == 2">
            <form @submit.prevent="submit1"  class="p-5 registro-2 ">
              <router-link to="/inicio">
                <img class="mb-4 mx-auto d-block logo-kallpa" src="@/assets/img/logo.png" alt="" width="" >
                </router-link>
            <div class="row g-3">
                <ul class="step d-flex flex-nowrap">
                        <li class="step-item ">
                            <a  @click="formulario=1" id="step1"></a>
                        </li>
                        <li class="step-item ">
                           <a v-if="button2==1" @click="formulario=2"  id="step2"></a>
                           <a v-else  id="step2"></a>
                        </li>
                        <li class="step-item active">
                            <a v-if="button3==1" @click="formulario=3" id="step3"></a>
                            <a v-else  id="step3"></a>
                        </li>
                         <li class="step-item" id="step4">
                            <a v-if="button4==1" @click="formulario=4" id="step4"></a>
                            <a v-else  id="step4"></a>
                        </li>
                    </ul> <br>
                     <p class="text-left" style="color: #1BCA59;">Todos los campos marcados (*) son obligatorios</p>
             <div class="col-md-12">
                <label for="Nacionalidad" class="form-label">País de residencia *</label>  
                <select class="form-select" aria-label="Default select example" id="Nacionalidad" name="Nacionalidad" v-model="registerForm.DatosPersonales.PaisResidencia" @change="obtenerSelectDepartamento" required>
                  <option v-for="(linea,index) in selectPais" :key="index" :value="linea.IdPais" v-text="linea.NombrePais" ></option>
                </select>
              </div> 
              <div v-if="registerForm.DatosPersonales.PaisResidencia=='200'">
                <div class="col-md-12">
                  <label for="Departamento" class="form-label">Departamento *</label>
                  <select class="form-select" id="Departamento" name="Departamento" aria-label="Default select example" v-model="registerForm.DatosPersonales.Departamento" @change="obtenerSelectProvincia"  required>
                      <option v-for="(linea,index) in selectDepartamento" :key="index" :value="linea.IdDepartamento" v-text="linea.NombreDepartamento" ></option>
                    </select>
                </div> 

                 <div class="col-md-12">
                  <label for="Provincia" class="form-label">Provincia *</label>
                  <select class="form-select" id="Provincia" name="Provincia" aria-label="Default select example" v-model="registerForm.DatosPersonales.Provincia" @change="obtenerSelectDistrito" required>
                     <option v-for="(linea,index) in selectProvincia" :key="index" :value="linea.IdProvincia" v-text="linea.NombreProvincia" ></option>
                    </select>
                </div> 

                <div class="col-md-12">
                  <label for="Distrito" class="form-label">Distrito *</label>
                  <select class="form-select" id="Distrito" name="Distrito" aria-label="Default select example" v-model="registerForm.DatosPersonales.Distrito" required>
                     <option v-for="(linea,index) in selectDistrito" :key="index" :value="linea.Ubigeo" v-text="linea.NombreDistrito" ></option>
                    </select>
                </div> 
              </div>
                <div class="col-md-12">
                  <label for="direccionp" class="form-label">Dirección: *</label>
                </div>
                <div class="col-md-12">
                  <input type="text" class="form-control" id="direccionp" name="direccionp"  v-model="registerForm.DatosPersonales.DireccionPersonal"  required> 
                </div>
                  <div class="col-md-12 d-flex justify-content-between">
                  <button type="button" v-on:click="formulario -= 1" class="btn btn-light"><i class="fas fa-arrow-left"></i> Volver </button>
                  <button type="submit"  class="btn btn-light">Siguiente <i class="fas fa-arrow-right"></i></button>
                  </div>
            </div>
            </form>
            </div>
            <div v-if="formulario == 3">
              <form @submit.prevent="submit1"  class="p-5 registro-2 ">
                <router-link to="/inicio">
                  <img class="mb-4 mx-auto d-block logo-kallpa" src="@/assets/img/logo.png" alt="" width="" >
                  </router-link>
              <div class="row g-3">
                 <ul class="step d-flex flex-nowrap">
                        <li class="step-item ">
                            <a  @click="formulario=1" id="step1"></a>
                        </li>
                        <li class="step-item">
                           <a v-if="button2==1" @click="formulario=2"  id="step2"></a>
                           <a v-else  id="step2"></a>
                        </li>
                        <li class="step-item">
                            <a v-if="button3==1" @click="formulario=3" id="step3"></a>
                            <a v-else  id="step3"></a>
                        </li>
                         <li class="step-item active" id="step4">
                            <a v-if="button4==1" @click="formulario=4" id="step4"></a>
                            <a v-else  id="step4"></a>
                        </li>
                    </ul> <br>
                     <p class="text-left" style="color: #1BCA59;">Todos los campos marcados (*) son obligatorios</p>
                  <div class="col-md-12">
                    <label for="TipoIdentidad" class="form-label">Documento de identidad *</label>
                    <select class="form-select" id="TipoIdentidad" name="TipoIdentidad" aria-label="Default select example" v-model="registerForm.DatosPersonales.IdTipoDocumentoIdentidad" @change="limpiarDoc"  required>
                      <option v-for="(linea,index) in selectTipoDoc" :key="index" :value="linea.Id" v-text="linea.NombreParametroValor" ></option>
                      </select>  
                  </div>

                  <div class="col-md-12">
                    <label for="DocumentoIdentidad" class="form-label">Número de documento *</label>
                    <input v-if="registerForm.DatosPersonales.IdTipoDocumentoIdentidad=='TIDO0001'"  type="text" class="form-control" id="DocumentoIdentidad" name="DocumentoIdentidad" v-model="registerForm.DatosPersonales.NumeroDocumentoIdentidad" minlength="8" maxlength="8"  required> 
                    <input v-else type="text" class="form-control" id="DocumentoIdentidad" name="DocumentoIdentidad" v-model="registerForm.DatosPersonales.NumeroDocumentoIdentidad" minlength="8" maxlength="20" required>  
                  </div> 
                  
                  <label for="" class="form-label" style="margin-bottom: -3%;">Agregar foto de DNI *</label>
                <div class="col-md-6">
                    <div class="file-upload" style="width: 250px;" >
                        <button class="file-upload-btn" type="button" onclick="$('.file-upload-input').trigger( 'click' )">Anverso</button>
                      
                        <div class="image-upload-wrap1" v-if="registerForm.DatosPersonales.ImgenBase64DniAnverso=='' || registerForm.DatosPersonales.ImgenBase64DniAnverso=='data:,'">
                          <input class="file-upload-input" type='file' @change="readURL1" required accept="image/*" />
                          <div class="drag-text">
                            <img src="@/assets/img/DNI.png" id="imageDniAnverso" alt="">
                          </div>
                        </div>
                        <div class="file-upload-content1" >
                          <img class="file-upload-image1" :src="registerForm.DatosPersonales.ImgenBase64DniAnverso" id="imageDniAnverso1" alt="" />
                          <div class="image-title-wrap">
                            <button v-if="mostrarImgA==true" type="button" @click="removeUpload1" class="remove-image">Eliminar <span class="image-title1">Uploaded Image</span></button>
                          </div>
                        </div>
                      </div> 
                </div>
                <div class="col-md-6">
                    <div class="file-upload" style="width: 250px;" >
                        <button class="file-upload-btn" type="button" onclick="$('.file-upload-input').trigger( 'click' )">Reverso</button>
                      
                        <div class="image-upload-wrap2" v-if="registerForm.DatosPersonales.ImgenBase64DniReverso=='' || registerForm.DatosPersonales.ImgenBase64DniReverso=='data:,'">
                          <input class="file-upload-input" type='file' @change="readURL2" required accept="image/*" />
                          <div class="drag-text">
                            <img src="@/assets/img/reverso.png" id="imageDniReverso" alt="">
                          </div>
                        </div>
                        <div class="file-upload-content2" >
                          <img class="file-upload-image2" :src="registerForm.DatosPersonales.ImgenBase64DniReverso" alt="" />
                          <div class="image-title-wrap">
                            <button v-if="mostrarImgR==true" type="button" @click="removeUpload2" class="remove-image">Eliminar <span class="image-title2">Uploaded Image</span></button>
                          </div>
                        </div>
                      </div> 
                </div>

                  <div class="col-md-12">
                    <label for="ExpuestaPoliticamente" class="form-label">¿Esta domiciliado en Perú? *<a href="" data-bs-toggle="modal" data-bs-target="#domiPeru"><i class="far fa-question-circle"></i></a> </label>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="flexDomiciliado" id="flexDomiciliado1" value="true" v-model="registerForm.DatosPersonales.Domiciliado" @click="limpiarPaisDomicilado" required>
                        <label class="form-check-label" for="flexDomiciliado1">
                        SI
                        </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="flexDomiciliado" id="flexDomiciliado2" value="false" v-model="registerForm.DatosPersonales.Domiciliado" required>
                      <label class="form-check-label" for="flexDomiciliado2">
                        NO
                      </label>
                    </div>
                    <div v-if="registerForm.DatosPersonales.Domiciliado=='false'" class="col-md-12"  disabled="true">
                      <label for="Nacionalidad" class="form-label">País de residencia *</label>  
                      <select class="form-select" aria-label="Default select example" id="PaisDomiciliado
                      " name="PaisDomicialiado" v-model="registerForm.DatosPersonales.PaisDomiciliado" @change="obtenerSelectDepartamento" required>
                        <option v-for="(linea,index) in selectPais" :key="index" :value="linea.IdPais" v-text="linea.NombrePais" ></option>
                      </select>
                    </div> 
                  </div>

                  <div class="col-md-12">
                    <label for="ExpuestaPoliticamente" class="form-label">¿Es persona expuesta
                        políticamente (PEP)? * <a href="" data-bs-toggle="modal" data-bs-target="#expuPoliticamente"><i class="far fa-question-circle"></i></a></label>
                  <div class="form-check">
                      <input class="form-check-input" type="radio" name="flexExPolitica" id="flexExPolitica3" value="true" v-model="registerForm.DatosPersonales.ExpuestaPoliticamente">
                      <label class="form-check-label" for="flexExPolitica3">
                        SI
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="flexExPolitica" id="flexExPolitica4" value="false" v-model="registerForm.DatosPersonales.ExpuestaPoliticamente" @click="limpiarPEP">
                      <label class="form-check-label" for="flexExPolitica4">
                        NO
                      </label>
                    </div>
                    <div v-if="registerForm.DatosPersonales.ExpuestaPoliticamente=='true'" disabled='true'>
                      <div class="col-md-12">
                        <label for="direccionp" class="form-label">Institucion: *</label>
                      </div>
                      <div class="col-md-12">
                        <input type="text" class="form-control" id="direccionp" name="direccionp" v-model="registerForm.DatosPersonales.Institucion"  required> 
                      </div>
                      <div class="col-md-12">
                        <label for="direccionp" class="form-label">Cargo: *</label>
                      </div>
                      <div class="col-md-12">
                        <input type="text" class="form-control" id="direccionp" name="direccionp"  v-model="registerForm.DatosPersonales.Cargo"  required> 
                      </div>
                    </div>
                  </div>
               
                 <div class="col-md-12 d-flex justify-content-between">
                  <button type="button" v-on:click="formulario -= 1" class="btn btn-light"><i class="fas fa-arrow-left"></i> Volver </button>
                  <button type="submit"  class="btn btn-light">Siguiente <i class="fas fa-arrow-right"></i></button>
                  </div>
              </div>
            </form>
            </div>

            <div v-if="formulario == 4">
            <form @submit.prevent="submit"  class="p-5 registro-2 ">
              <router-link to="/inicio">
                <img class="mb-4 mx-auto d-block logo-kallpa" src="@/assets/img/logo.png" alt="" width="" >
                </router-link>
            <div class="row g-3">
              <ul class="step d-flex flex-nowrap">
                        <li class="step-item ">
                            <a  @click="formulario=1" id="step1"></a>
                        </li>
                        <li class="step-item ">
                           <a v-if="button2==1" @click="formulario=2"  id="step2"></a>
                           <a v-else  id="step2"></a>
                        </li>
                        <li class="step-item">
                            <a v-if="button3==1" @click="formulario=3" id="step3"></a>
                            <a v-else  id="step3"></a>
                        </li>
                         <li class="step-item" id="step4">
                            <a v-if="button4==1" @click="formulario=4" id="step4"></a>
                            <a v-else  id="step4"></a>
                        </li>
                    </ul> <br>
                     <p class="text-left" style="color: #1BCA59;">Todos los campos marcados (*) son obligatorios</p>
               <div class="col-md-12">
                  <label for="profecioOcupacion" class="form-label">Profesión / Ocupación *</label>
                  <input type="text" class="form-control" id="profecioOcupacion" name="profecioOcupacion"  v-model="registerForm.DatosLaborales.Profesion" @keypress="soloLetrasSimples" required>
                </div>

                <div class="col-md-12"> 
                  <div class="form-check" v-for="(linea,index) in selectStatusLaboral " :key="index">
                    <input class="form-check-input" type="radio" name="flexRadioDefault" :id="linea.NombreParametroValor" :value="linea.Id" v-model="registerForm.DatosLaborales.StatusLaboral" @change="mostrarDatosLaborales">
                    <label class="form-check-label" :for="linea.NombreParametroValor" v-text="linea.NombreParametroValor">
                    </label>
                  </div>
                </div>
                <div v-if="registerForm.DatosLaborales.StatusLaboral!='TICL0003'">
                <div class="col-md-12">
                  <label for="empresa" class="form-label">Empresa *</label>
                  <input type="text" class="form-control" id="empresa" name="empresa"   v-model="registerForm.DatosLaborales.Empresa" @keypress="soloLetrasSimples" required>
                </div>

                <div class="col-md-12">
                  <label for="cargo" class="form-label">Cargo *</label>
                  <input type="text" class="form-control" id="cargo" name="cargo"   v-model="registerForm.DatosLaborales.Cargo" @keypress="soloLetrasSimples" required>
                </div>

                <!-- <div class="col-md-12">
                  <label for="tiempoServicio" class="form-label">Tiempo de servicio *</label>
                  <input type="text" class="form-control" id="tiempoServicio" name="tiempoServicio"  placeholder="" value="" v-model="registerForm.DatosLaborales.TiempoServicio"  required>
                </div>

                  <div class="col-md-12">
                  <label for="ingresoAnual" class="form-label">Ingresos Anuales (S/) *</label>
                  <input type="text" class="form-control" id="ingresoAnual" name="ingresoAnual"  placeholder="" value="" v-model="registerForm.DatosLaborales.IngresoAnual" @keypress="soloFloat" required>
                </div>

                <div class="col-md-12">
                  <label for="direccion" class="form-label">Dirección de la empresa *</label>
                  <input type="text" class="form-control" id="direccion" name="direccion"  placeholder="" value="" v-model="registerForm.DatosLaborales.DireccionLaboral" required>
                </div>

                 <div class="col-md-12">
                  <label for="telefonoEmpresa" class="form-label">Teléfono de la empresa *</label>
                  <input type="text" class="form-control" id="telefonoEmpresa" name="telefonoEmpresa"  placeholder="" value="" v-model="registerForm.DatosLaborales.TelefonoEmpresa" @keypress="soloNumeros" required>
                </div> -->

              
              </div>
              <!-- <div class="col-md-12">
                  <label for="ingresoAnual" class="form-label">
                    <span style="font-size: 18px;">DECLARACIÓN JURADA DE ORIGEN DE FONDOS *</span> </label>
                  <p class="text-left" style="font-size: 15px;">Declaro que los fondos que utilizaré para realizar mis operaciones de cambio de moneda a través de Kallpa Cambios provienen de las siguientes fuentes:</p>
                  <br>

                  <div class="form-check" v-for="(linea,index) in selectOrigenFondo" :key="index" >
                    <input class="form-check-input" type="checkbox" :value="linea.Id" :id="linea.Id" v-model="registerForm.DatosLaborales.DeclJuradaOrigenFondo">
                    <label class="form-check-label" :for="linea.Id" v-text="linea.NombreParametroValor">
                    </label>
                  </div>
                  <div class="col-md-12">
                  <input type="text" v-if="mostrarOtr==1" class="form-control" id="especificar" name="especificar"  placeholder="Especificar" v-model="registerForm.DatosLaborales.OtrosEspecifico" >
                  </div>
              </div> -->
                  <p class="m-t text-center politicas">
                    Al CREAR LA CUENTA ACEPTA 
                    <a :href="urlTerminosCondiciones" target="_blank">TERMINOS & CONDICIONES </a>  & 
                    <a :href="urlPoliticasSeguridad" target="_blank">POLÍTICAS DE PRIVACIDAD</a>
                  </p>
                  <div class=""><button class="w-100 btn btn-lg btn btn-registro " type="submit">Registrarme</button></div> 
                  <p class="text-center">¿ Ya tienes una cuenta ? <a>Iniciar sesión</a> </p>
                  <div class="col-md-12 d-flex justify-content-between">
                  <button type="button" v-on:click="formulario -= 1" class="btn btn-light"><i class="fas fa-arrow-left"></i> Volver </button></div>
            </div>




            </form>
            </div>
        
    </main>

<!-- Modal domiciliado en Perú -->
<div class="modal fade" id="domiPeru" tabindex="-1" aria-labelledby="domiPeruLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
     <div class="m"><button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button></div>
      <div class="modal-body">
        <p style="text-align: justify;">*Domiciliado: <br>
          (i)Las personas naturales de nacionalidad peruana que tengan domicilio en el país, (ii) Las personas naturales extranjeras que hayan
          residido o permanecido en el país más de ciento ochenta y tres (183) días calendario durante un periodo cualquiera de doce (12) meses. Art. 7 º del D. S . Nº
          179-2004-EF.
          </p>
      </div>
    </div>
  </div>
</div>
<!-- Modal domiciliado en Perú -->

<!-- Modal expuesto politicamente -->
<div class="modal fade" id="expuPoliticamente" tabindex="-1" aria-labelledby="expuPoliticamenteLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="m"><button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button></div>
      <div class="modal-body">
        <p style="text-align: justify;">** Personas naturales nacionales o extranjeras que cumplen o que en los últimos cinco (5) años hayan cumplido funciones públicas destacadas o funciones
        prominentes en una organización internacional, sea en el territorio nacional o extranjero, y cuyas circunstancias financieras puedan ser objeto de interés público,
        debiéndose considerar las categorías mencionadas en el Anexo V de Resolución Superintendente Nro.00073-2018 del 31/05/2018. <br>

        En el caso de los PEP, nombre de sus parientes hasta el segundo grado de consanguinidad y segundo de afinidad y del cónyuge o concubino, de ser el caso, así
        como la relación de personas jurídicas o entes jurídicos donde el PEP mantenga una participación igual o superior al 25% de su capital social, aporte o
        participación
          </p>
      </div>
    </div>
  </div>
</div>
<!-- Modal expuesto politicamente -->

<!-- Modal gracias -->
<div class="modal fade" id="gracias" tabindex="-1" aria-labelledby="graciasLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div v-if="isLoad==1">
            <img src="@/assets/img/logo.png" alt="logo" class="logo-kallpa text-center"> <br>
            <h3 class="titulo-registro text-center">¡Gracias por registrarte en Kallpa Cambios!</h3> <br>
            <p style="text-align: justify;">
            Ya estás casi listo. Te hemos enviado un correo electrónico de verificación. Por favor ingresa a tu bandeja de correo y haz clic en el enlace que se muestra en el mensaje.
            </p>
            <div class="modal-footer">
                <button type="button" data-bs-dismiss="modal" @click="$router.push('/auth-login').catch(err => {})" class="btn btn-registro">Continuar</button>
            </div>
        </div>
        <div v-if="isLoad==0" class="cargando">
        </div>
        <div v-if="isLoad==2" >
          <center><img src="@/assets/img/error.png" alt="logo" class="text-center"></center> <br>
          <p style="text-align: justify;" v-text="mensajeError">
            </p>
            <div class="modal-footer">
                <button type="button" data-bs-dismiss="modal" @click="isLoad=0"  class="btn btn-registro">Volver</button>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal gracias -->

    
</div>   
</template>

<script>

import helpers from '@/services/helpers'
import auth from '@/services/auth'
import VeeValidate, { Validator } from "vee-validate";


export default {
  name: "Registro",
  
  data() {
    return {
      parametrosGenerales:[],
      selectPais:[],
      selectDepartamento:[],
      selectNacionalidad:[],
      selectProvincia:[],
      selectDistrito:[],
      selectTipoDoc:[],
      selectStatusLaboral:[],
      selectOrigenFondo:[],
      registerForm: {
        DatosPersonales:{
          Nombres:"",
          Apellidos:"",
          Celular: "",
          FechaNacimiento:"",
          Nacionalidad:"", //Peruana, Brasileño , etc
          Email:"",
          Clave:"",
          PaisResidencia:"",
          Departamento:"",
          Provincia:"",
          Distrito:"", // campo UBIGEO mando por parametro general
          DireccionPersonal:"",
          IdTipoDocumentoIdentidad:"", // DNI, PASAPORTE u otros
          NumeroDocumentoIdentidad:"",
          ImgenBase64DniAnverso:"",
          ImgenBase64DniReverso:"",
          Domiciliado:"",
          PaisDomiciliado: "",
          ExpuestaPoliticamente:"",
          Institucion: "",
          Cargo: "",
        },
        DatosLaborales:{
          Profesion:"",
          StatusLaboral:"", //Independiente, dependiente o No labora
          Empresa:"",
          Cargo:"",
        },
      },
      fechaNacimiento:"",
      button2:0,
      button3:0,
      button4:0,
      origenOtrosDet:"",
      origenFondosArray:[],
      mostrarOtr:"0",
      deshabilitado: false,
      formulario:1,
      urlTerminosCondiciones: '#',
      urlPoliticasSeguridad: '#',
      mostrarImgA:false,
      mostrarImgR:false,
      isLoad:0,
      mensajeError:"",
    };
  },

  watch: {
        fechaNacimiento: function(val, oldVal) {
        }
    },

  mounted() {
    helpers.habilitarBoton(this);
    Validator.extend('verify_password', {
        getMessage: field => `La Clave debe contener al menos: 1 letra mayúscula, 1 letra minúscula, 1 número y un carácter especial`,
        validate: value => {
            var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+=!%^&*-.,])(?=.{5,})");
            return strongRegex.test(value);
        }
    });
    $('#datetimepicker2').datepicker({
          format: "dd/mm/yyyy",
          language: "es",
          autoclose: true,
          todayHighlight: true
      });
  },
  beforeCreate(){
    helpers.actualizarTipoCambio(this);
    auth.listParameters().then(response => {
      this.parametrosGenerales=response;
      this.obtenerSelectPais();
      this.obtenerSelectNacionalidad();
      this.obtenerSelectTipoDoc();
      this.obtenerSelectStatusLaboral();
      this.obtenerUrlsRedireccionMensajes();
    });

    $('.image-upload-wrap1').bind('dragover', function () {
      $('.image-upload-wrap1').addClass('image-dropping');
    });
    $('.image-upload-wrap1').bind('dragleave', function () {
        $('.image-upload-wrap1').removeClass('image-dropping');
    });
    $('.image-upload-wrap2').bind('dragover', function () {
      $('.image-upload-wrap2').addClass('image-dropping');
    });
    $('.image-upload-wrap2').bind('dragleave', function () {
        $('.image-upload-wrap2').removeClass('image-dropping');
    });
  },
  methods: {
    mostrarOtros(){
      if(document.getElementById('flexCheckOtros').checked) {
        this.mostrarOtr=1;
      }
      else{
        this.origenOtrosDet="";
        this.mostrarOtr=0;
      }
    },
    submit1(e) {
      window.scrollTo(0, 0);
      this.formulario +=1;
      switch (this.formulario) {
        case 2: 
          this.button2=1;
          break;
        case 3: 
        this.button3=1;
          break;
        case 4: 
        this.button4=1;
          break;
      }
          
    },
    limpiarDoc() {
      this.registerForm.DatosPersonales.NumeroDocumentoIdentidad="";    
    },
    submit(e) {
      $('#gracias').modal('show');
      window.scrollTo(0, 0);
       auth.register(this).then(response => {
        if(response==true){
          this.isLoad=1;
        }
        else{
          this.mensajeError=response;
          this.isLoad=2;
        }
      })
     
    },

    soloNumeros($event){
          helpers.soloNumeros($event);
    },
    soloLetrasSimples($event){
          helpers.soloLetrasSimples($event);
    },

    mostrarDatosLaborales(){
      if(this.registerForm.DatosLaborales.StatusLaboral!='TICL0003'){
      this.registerForm.DatosLaborales.Empresa="";
      this.registerForm.DatosLaborales.Cargo="";
     
    }
    },

    obtenerSelectDepartamento(){
      if(this.registerForm.DatosPersonales.PaisResidencia=="200"){
        this.selectDepartamento=this.parametrosGenerales.ParametrosGeneralesUbigeo[0].Departamento;
      }
      else{
        this.selectDepartamento="";
        this.selectProvincia="";
        this.selectDistrito="";
        this.registerForm.DatosPersonales. Departamento="";
        this.registerForm.DatosPersonales.Provincia="";
        this.registerForm.DatosPersonales.Distrito="";
      }
      
    },
    obtenerSelectPais(){
      this.selectPais=this.parametrosGenerales.ParametrosGeneralesUbigeo[0].Pais;
    },
    obtenerSelectNacionalidad(){
      this.selectNacionalidad=this.parametrosGenerales.ParametrosGenerales.filter(e=>e.IdParametro=="TINA");
    },
    obtenerSelectProvincia(){
      this.selectProvincia=this.parametrosGenerales.ParametrosGeneralesUbigeo[0].Provincia.filter(e=>e.IdDepartamento==this.registerForm.DatosPersonales.Departamento);
      this.selectDistrito="";
    },
    obtenerSelectDistrito(){
       this.selectDistrito=this.parametrosGenerales.ParametrosGeneralesUbigeo[0].Distrito.filter(e=>e.IdProvincia==this.registerForm.DatosPersonales.Provincia);
    },
    obtenerSelectTipoDoc(){
      this.selectTipoDoc=this.parametrosGenerales.ParametrosGenerales.filter(e=>e.IdParametro=="TIDO");
    },
    obtenerSelectStatusLaboral(){
      this.selectStatusLaboral=this.parametrosGenerales.ParametrosGenerales.filter(e=>e.IdParametro=="TICL");
    },
    obtenerUrlsRedireccionMensajes(){
      let urlTerminosCondiciones = this.parametrosGenerales.ParametrosGenerales.find(e=>e.Id == "MENS0006");
      let urlPoliticasSeguridad = this.parametrosGenerales.ParametrosGenerales.find(e=>e.Id == "MENS0007");
      this.urlTerminosCondiciones = urlTerminosCondiciones.DetalleParametroValor;
      this.urlPoliticasSeguridad = urlPoliticasSeguridad.DetalleParametroValor;
      this.selectOrigenFondo=this.parametrosGenerales.ParametrosGenerales.filter(e=>e.IdParametro=="DEOR");
    },

      async readURL1(ev) {
        var input=ev.target;
        if (input.files && input.files[0]) {
          var reader = new FileReader();
          //var img=await this.loadImage();
          
         this.loadImage(reader,input).then(result=>{
           this.registerForm.DatosPersonales.ImgenBase64DniAnverso=result;  
           })
          reader.readAsDataURL(input.files[0]);
          this.mostrarImgA=true;
          
        } else {
          removeUpload1();
        }
        },

        loadImage(reader,input){
          return new Promise((resolve)=>{
            reader.onload =   function(e){
             $('.image-upload-wrap1').hide();
             $('.file-upload-image1').attr('src', e.target.result);
             $('.file-upload-content1').show();

             $('.image-title1').html(input.files[0].name);
            resolve(e.target.result);
            }

          })
        },

        loadImage2(reader,input){
          return new Promise((resolve)=>{
            reader.onload =   function(e){
             $('.image-upload-wrap2').hide();
             $('.file-upload-image2').attr('src', e.target.result);
             $('.file-upload-content2').show();

             $('.image-title2').html(input.files[0].name);
            resolve(e.target.result);
            }

          })
           
        },

        soloFloat($event){
          helpers.soloFloat($event);
        },

        removeUpload1() {
        //$('.file-upload-input').replaceWith($('.file-upload-input').clone());
        $('.file-upload-content1').hide();
        $('.image-upload-wrap1').show();
        this.registerForm.DatosPersonales.ImgenBase64DniAnverso="";
        this.mostrarImgA=false;
        },

        readURL2(ev) {
        var input=ev.target;
        if (input.files && input.files[0]) {
          var reader = new FileReader();
          //var img=await this.loadImage();
          
         this.loadImage2(reader,input).then(result=>{
           this.registerForm.DatosPersonales.ImgenBase64DniReverso=result;  
           })
          reader.readAsDataURL(input.files[0]);
          this.mostrarImgR=true;
          
        } else {
          removeUpload2();
        }
        },

        removeUpload2() {
        
        //$('.file-upload-input').replaceWith($('.file-upload-input').clone());
        $('.file-upload-content2').hide();
        $('.image-upload-wrap2').show();
        this.registerForm.DatosPersonales.ImgenBase64DniReverso="";
        this.mostrarImgR=false;
        },

        getBase64Image(img) {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          var dataURL = canvas.toDataURL();
          return dataURL;
        },
        mostrarFechaNacimiento(){
          alert("entro");
          this.registerForm.DatosPersonales.FechaNacimiento=this.fechaNacimiento;
        },
        mostrarClave(){
          var cambio = document.getElementById("Clave");
        if(cambio.type == "password"){
          cambio.type = "text";
          $('.icon1').removeClass('fa fa-eye-slash').addClass('fa fa-eye');
        }else{
          cambio.type = "password";
          $('.icon1').removeClass('fa fa-eye').addClass('fa fa-eye-slash');
        }
        },
        mostrarClaveRepetida(){
          var cambio = document.getElementById("ClaveRepetida");
        if(cambio.type == "password"){
          cambio.type = "text";
          $('.icon2').removeClass('fa fa-eye-slash').addClass('fa fa-eye');
        }else{
          cambio.type = "password";
          $('.icon2').removeClass('fa fa-eye').addClass('fa fa-eye-slash');
        }
        },
        limpiarPaisDomicilado(){
          this.registerForm.DatosPersonales.PaisDomiciliado="";
        },
        limpiarPEP(){
          this.registerForm.DatosPersonales.Institucion="";
          this.registerForm.DatosPersonales.Cargo="";
        },
        navegar(){
          
            alert("validado");
          
        }
      
  },

};
</script>




// WEBPACK FOOTER //
// src/components/auth/Registro.vue